import { render, staticRenderFns } from "./TOrderCard.vue?vue&type=template&id=fe73ab86&scoped=true&"
import script from "./TOrderCard.vue?vue&type=script&lang=js&"
export * from "./TOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./TOrderCard.vue?vue&type=style&index=0&id=fe73ab86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe73ab86",
  null
  
)

/* custom blocks */
import block0 from "./TOrderCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports